import { createFileRoute } from "@tanstack/react-router";
import { AccessLogPage } from "@/components/pages/AccessLogPage";

export const Route = createFileRoute("/invitations/access-log")({
  component: AccessLogPage,
});
